export const DSA_PROJECT_ID = "defisansautosolo-17ee7";

export const isDsaProject = () => import.meta.env.VITE_FIREBASE_PROJECT_ID === DSA_PROJECT_ID;

const DEFAULT_GREENPOINTS_RATIO = 100;
const DSA_RAFFLE_RATIO = 200;
const DSA_INSTANT_RATIO = 1000;

// `data.isCoupon` marks a raffle reward (Coupon de tirage); anything else on
// the DSA counts as an instant reward (Récompense instantanée).
export const getGreenpointsRatio = (data = {}) => {
  if (!isDsaProject()) return DEFAULT_GREENPOINTS_RATIO;
  return data?.isCoupon ? DSA_RAFFLE_RATIO : DSA_INSTANT_RATIO;
};

export const computeGreenpoints = (data = {}) =>
  Number((Number(data?.price) || 0) * getGreenpointsRatio(data));
